(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('PolicyController', PolicyController);

    PolicyController.$inject = ['$scope', '$state','$filter', 'CONST_RECEIPT', 'CommonService', 'PolicyService', 'ReceiptService' ,'AlertService', '$timeout', '$location', '$uibModal', 'entity', 'policy', 'mode', 'CustomerService', '$stateParams', '$base64', 'FORMAT_DATE', 'CONST_COMMON','authExpiredInterceptor', 'Upload', '$window'];

    function PolicyController ($scope, $state,$filter, CONST_RECEIPT, CommonService, PolicyService, ReceiptService, AlertService, $timeout, $location, $uibModal, entity, policy, mode, CustomerService, $stateParams, $base64, FORMAT_DATE, CONST_COMMON,authExpiredInterceptor, Upload, $window) {
    	var policyCtr = this;
    	var self = $scope;
    	var receiptScope = self.$parent;
    	self.policy = {};
    	self.isClick= false;
		policyCtr.receiptMaster = {};
		policyCtr.thirdParty = {};
    	self.PDK = '1';
    	self.HTTD = '2';
    	self.HTTU = '3';
    	self.KK = '4';
    	self.PG = '7';
    	self.SubType_10 = '10';
		self.SubType_12 = '12';
		self.totalAmountThirdParty = 0;
    	self.totalAmountThirdPartyTemp = 0;
    	self.clickCheckThirdParty = false;
    	self.isRevert = true;
    	self.isFullyPaid = false;
    	self.isDisableReceiptType = false;
    	self.receipt.receiptSubTypeDescription = 'Phí HD cho thời hạn';
    	self.isDisablePDKorKK = false;
    	self.isDisablePDKorKKFind = false;
    	policyCtr.isPaymentTypeBankOrPost = false;
		policyCtr.isAgent = true;
		policyCtr.isThirdParty = false;
    	policyCtr.checkCreatD61D70 = false;
    	policyCtr.showHistoryD61D70 = true;
    	policyCtr.checkApprovalD61D70 = false;
    	policyCtr.lstRequestType = CONST_RECEIPT.LST_REQUEST_TYPE;
		policyCtr.lstRequestSubType = CONST_RECEIPT.LST_REQUEST_SUB_TYPE;
		policyCtr.laspeActionN = '0';

    	self.receiptTypesAll = CommonService.query({masterurl:'receipt-types'}, function(result) {
			self.receiptTypesAll = result;
		});
    	self.receiptTypesNotInEligibility = CommonService.query({masterurl:'receipt-types'}, function(result) {
			self.receiptTypesNotInEligibility = _.remove(result, function(currentObject) {
			    return currentObject.receiptTypeCode !== '7';
			});
		});
    	self.changeStatusReceiptDueDate = changeStatusReceiptDueDate;
    	policyCtr.init = init;
    	policyCtr.lstNationality = CommonService.query({masterurl:'nationality'});
    	policyCtr.lstThirdParty = CommonService.query({masterurl:'thirdParty'});
    	self.dataFileName = '';
    	
    	policyCtr.changeAgent = function(paymentType,value){
    		if(paymentType == 'CASH'){
    			if(value) {
    				self.receipt.receiptAgDate = null;
    			}else {
    				self.receipt.receiptAgentCode = null;
    				self.receipt.receiptAgentName = null;
    				self.receipt.receiptAgNum = null;
    				self.receipt.receiptAgDate = new Date();
    			}
    		}
    	}
    	policyCtr.changePaymentType = function(code){
    		if(code == 'CASH'){
    			policyCtr.isPaymentTypeBankOrPost = false;
    			if(policyCtr.isAgent) {
    				self.receipt.receiptAgDate = null;
    			}else {
    				self.receipt.receiptAgNum = null;
    				self.receipt.receiptAgDate = new Date();
    			}
    			self.receipt.bankReceiptBrNum = null;
    			if(self.receipt.eTrrbReceiptId != null && (self.receipt.eTrrbReceiptId != undefined || self.receipt.eTrrbReceiptId != '')) {
    				self.receipt.receiptAgNum = policyCtr.receiptMaster.receiptAgNum == null ? policyCtr.receiptMaster.bankReceiptBrNum : policyCtr.receiptMaster.receiptAgNum;
    				self.receipt.receiptAgDate = policyCtr.receiptMaster.receiptAgDate == null ? policyCtr.receiptMaster.bankReceiptBrDate : policyCtr.receiptMaster.receiptAgDate;
    			}
    		}else {
    			self.bankPosts = CommonService.query({masterurl:'get-bank-post',paymentType:code}, function(result) {
    	    		self.bankPosts = result;
    			});
    			self.receipt.receiptAgNum = null;
    			self.receipt.bankReceiptBankDate = new Date();
    			policyCtr.isPaymentTypeBankOrPost = true;
    			policyCtr.isAgent = true;
    			if(self.receipt.eTrrbReceiptId != null && (self.receipt.eTrrbReceiptId != undefined || self.receipt.eTrrbReceiptId != '')) {
    				self.receipt.bankReceiptBankAmount = policyCtr.receiptMaster.receiptAgAmount;
    				self.receipt.bankReceiptBrAmount = policyCtr.receiptMaster.receiptAgAmount;
    				self.receipt.bankReceiptBrNum = policyCtr.receiptMaster.receiptAgNum == null ? policyCtr.receiptMaster.bankReceiptBrNum : policyCtr.receiptMaster.receiptAgNum;
    				self.receipt.receiptTotalAmount = policyCtr.receiptMaster.receiptAgAmount;
    				self.receipt.receiptAgentCode = policyCtr.receiptMaster.receiptAgentCode;
    				self.receipt.receiptAgentName = policyCtr.receiptMaster.receiptAgentName;
    				self.receipt.bankReceiptBrDate = policyCtr.receiptMaster.receiptAgDate == null ? policyCtr.receiptMaster.bankReceiptBrDate : policyCtr.receiptMaster.receiptAgDate;
    				self.receipt.bankReceiptBankDate = policyCtr.receiptMaster.receiptAgDate == null ? policyCtr.receiptMaster.bankReceiptBrDate : policyCtr.receiptMaster.receiptAgDate;
    				self.receipt.receiptDueDate = policyCtr.receiptMaster.paidToDateAdvance == null ? new Date() : policyCtr.receiptMaster.paidToDateAdvance;
    			}
    		}
    		
    		caculatorReceiptAmount();
    	};
    	 
    	function init(){
    		self.$parent.title = CONST_RECEIPT.POLICY_PAGE_TITLE;
    		receiptScope.policyNumDisable = false;
    		receiptScope.isDisable = false;
    		self.isBom = true;
    		self.receipt.countSubmit = 0;
    		receiptScope.isTrrb = false;
    		
        	self.receiptSubTypes = CommonService.query({masterurl:'receipt-subtypes'});
        	
    		if(entity != null) {
    			self.$parent.receipt =entity;
    			// End ETRRB

				if (entity.thirdPartyInfoDto != null) {
    				policyCtr.thirdParty = entity.thirdPartyInfoDto;
    				policyCtr.isThirdParty = true;
    				
        			if(entity.thirdPartyInfoDto.archiveData != null) {        				
        				policyCtr.attachment = {
    						name : entity.thirdPartyInfoDto.archiveData.dataName,
    						content : entity.thirdPartyInfoDto.archiveData.content,
    						type : entity.thirdPartyInfoDto.archiveData.dataType
						};
						
    					self.dataFileName = entity.thirdPartyInfoDto.archiveData.dataName;
					}
					
        			policyCtr.thirdParty.birthdayDate = new Date(entity.thirdPartyInfoDto.birthDay);
				}

    			if(entity.paymentTypeCode == 'CASH'){
        			policyCtr.isPaymentTypeBankOrPost = false;
        			if(entity.receiptAgNum === null || entity.receiptAgNum === undefined){
        				policyCtr.isAgent = false;
        			}else{
        				policyCtr.isAgent = true;
        			}
        		}else {
        			self.bankPosts = CommonService.query({masterurl:'get-bank-post',paymentType:entity.paymentTypeCode}, function(result) {
        	    		self.bankPosts = result;
        			});
        			policyCtr.isPaymentTypeBankOrPost = true;
        			if(entity.bankReceiptBrNum === null || entity.bankReceiptBrNum === undefined){
        				policyCtr.isAgent = false;
        			}else{
        				policyCtr.isAgent = true;
        			}
        		}

    			receiptScope.receiptsMustPrint = entity.receiptsMustPrint;
    			receiptScope.txnId = entity.transaction.txnId;
    			receiptScope.receiptId = entity.receiptId;
    			receiptScope.paymentTypeCode = entity.paymentTypeCode;
    			if ($stateParams.taskId != undefined && $stateParams.taskId != '') {
        			self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
        			self.isBom = true;
    			}else {
    				self.isBom = false;
    			}
    			if(policy != null){
    				if(self.receipt.receiptPremiumAmount != undefined && self.receipt.receiptPremiumAmount != null)
    					policy.premiumAmount = self.receipt.receiptPremiumAmount;
	    				policy.receiptDeductAmount = self.receipt.receiptDeductAmount;
	    				policy.dayPolicy = self.receipt.dayPolicy;
	    				self.policy = policy;   
	    				self.receipt.policyNum = policy.policyNum;
	    				self.receipt.policyULP = policy.policyULP;
	    				self.policy.allReceiptDueDates = [self.receipt.receiptDueDate];
	    				self.receiptTypes = self.receiptTypesAll;
	    				if(self.receipt.receiptTypeCode === self.PG){
	    					CommonService.query({masterurl:'receipt-types'}, function(result) {
	    						self.receiptTypes = result;
	    					});
	    				}
	    					
	    				self.changeStatusReceiptDueDate();
	    				if (self.receipt.receiptTypeCode == self.PDK && policy.policyULP)
	    					self.receipt.showDescription = true;
	    				else
	    					self.receipt.showDescription = false;
	    				
	    				// ETRRB
	        			if($state.params.etrrbReceiptId != null || entity.eTrrbReceiptId != null) {
	        				receiptScope.isTrrb = true;
	        				self.receipt.receiptDueDate = policy.paidToDateAdvance == null ? new Date() : policy.paidToDateAdvance ;
						}
						policyCtr.laspeActionN = policy.laspeActionN;
    			}
    			
    			receiptScope.isDisable = true;
    			self.isDisableReceiptType = true;
    			
    			//nếu edit or view => disable
    			receiptScope.policyNumDisable = true;
    			// Neu transaction sucess -> disable
    			if(entity.receiptNum != null)
    			{
    				receiptScope.isDisable = true;
    				self.isDisableReceiptType = true;
    				ReceiptService.returnValue({uri:'get-tax-invoice-no',receiptNum:entity.receiptNum},function(result) {
						if(result != null && result.response != null && result.response != '')
							self.receipt.taxInvoiceNo = result.response;
					})
    			}
    			if(entity.transaction.wfStatus == 'RECEIPT_END') {
    				receiptScope.isTrrb = false;
    				self.isBom = false;
    			}
    				
    		}else {
    			self.$parent.receipt ={ transaction: {txnType: CONST_RECEIPT.TRANSACTION_TYPE_POLICY, txnEnable:1}, customerType: null};
    			self.receipt.paymentTypeCode = 'CASH';
    	        self.receipt.receiptTypeCode = '1';
    	        
            	self.receipt.bankReceiptBrDate = new Date();
    		}
    		
        	self.receipt = self.$parent.receipt;
        	self.receipt.isGamFixedSubmit = ($stateParams.taskId != undefined && $stateParams.taskId != '' && $stateParams.taskId != null) ? 'Y' : 'N';
        	if(($stateParams.taskId != undefined && $stateParams.taskId != '' && $stateParams.taskId != null)){
        		policyCtr.showHistoryD61D70 = false;
        	}
        	self.receipt.createdDate = self.receipt.transaction.createdDate;
        	receiptScope.mode  = mode;
        	
            policyCtr.receiptMaster = angular.copy(self.receipt);
    	}
    	    	
    	policyCtr.init();
    	
    	policyCtr.receiptCancelReason = receiptCancelReason;
    	policyCtr.checkReceiptDate = checkReceiptDate;
    	/*
    	 * Create receipt by policy
    	 */
    	policyCtr.save = function () {
    		self.isClick = true;
    		if (self.receipt.isDataEtrrb != '1') {
	    		ReceiptService.save({uri:"check-audit"}, self.receipt, function(data) {
	    			ReceiptService.save({uri:"check-proposal-link-tr"}, self.receipt, function(data) {
	    				
	    				if (data.flgError == '1') {
	        				var detailMessage = data.messageAuditPopop;
	        				var fileUpload1 = 0;
	        				var fileUpload2 = 0;

	    					var modalInstance = $uibModal.open({
	    						animation : true,
	    						templateUrl : GLOBAL_URL
	    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    						controller : 'AuditConfirmController',
	    						controllerAs : 'vm',
	    						size : 'lg',
	    						resolve : {
	    							detailMessage : function() {
	    								return detailMessage;
	    							},
	    							fileUpload1 : function() {
	    								return fileUpload1;
	    							},
	    							fileUpload2 : function() {
	    								return fileUpload2;
	    							},
	    							receipt : function() {
	    								return self.receipt;
	    							}
	    						}
	    					});
	    					
	    					modalInstance.result.then(function(result) {
	    						if(result =='1') {
	    							ReceiptService.save({uri:"check-expired-tr"}, self.receipt, function(data) {
	    								
	    								if (data.flgError == '1') {
	    			        				var detailMessage = data.messageAuditPopop;
	    			        				var fileUpload1 = 1;
	    			        				var fileUpload2 = 0;
	
	    			    					var modalInstance = $uibModal.open({
	    			    						animation : true,
	    			    						templateUrl : GLOBAL_URL
	    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    			    						controller : 'AuditConfirmController',
	    			    						controllerAs : 'vm',
	    			    						size : 'lg',
	    			    						resolve : {
	    			    							detailMessage : function() {
	    			    								return detailMessage;
	    			    							},
	    			    							fileUpload1 : function() {
	    			    								return fileUpload1;
	    			    							},
	    			    							fileUpload2 : function() {
	    			    								return fileUpload2;
	    			    							},
	    			    							receipt : function() {
	    			    								return self.receipt;
	    			    							}
	    			    						}
	    			    					});
	    			    					
	    			    					modalInstance.result.then(function(result) {
	    			    						if(result =='1') {
	    			    							ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
	    			    								if (data.flgError == '1') {
	    			    			        				var detailMessage = data.messageAuditPopop;
	    			    			        				var fileUpload1 = 0;
	    			    			        				var fileUpload2 = 1;
	
	    			    			    					var modalInstance = $uibModal.open({
	    			    			    						animation : true,
	    			    			    						templateUrl : GLOBAL_URL
	    			    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    			    			    						controller : 'AuditConfirmController',
	    			    			    						controllerAs : 'vm',
	    			    			    						size : 'lg',
	    			    			    						resolve : {
	    			    			    							detailMessage : function() {
	    			    			    								return detailMessage;
	    			    			    							},
	    			    			    							fileUpload1 : function() {
	    			    			    								return fileUpload1;
	    			    			    							},
	    			    			    							fileUpload2 : function() {
	    			    			    								return fileUpload2;
	    			    			    							},
	    			    			    							receipt : function() {
	    			    			    								return self.receipt;
	    			    			    							}
	    			    			    						}
	    			    			    					});
	    			    			    					
	    			    			    					modalInstance.result.then(function(result) {
	    			    			    						if(result =='1') {
	    			    			    							saveContinue();
	    			    			    						} else {
	    			    			    							self.receipt.archiveDataReportExpiredTr = null;
	    			    			    							self.receipt.archiveDataReportCorrectTr = null;
	    			    			    						}
	    			    			    						
	    			    			    						receiptScope.loading = false;
	    			    			    					});
	    			    			    					
	    			    								} else {
	    			    									saveContinue();
	    			    								}
	    			    							}, function (error) {
	    			    								if(error.status !== 500) {
	    			    				        			self.receipt = error.data;
	    			    				        		}
	    			    				        		
	    			    				        		receiptScope.loading = false;
	    			    				        		
	    			    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	    			    				        			self.receipt.countSubmit += 1;
	    			    				        		}
	    			    				        		
	    			    				        		if(self.receipt.countSubmit >= 2){
	    			    				        			 receiptScope.isDisable = true;
	    			    				        			 self.isDisableReceiptType = true;
	    			    				         		}
	    			    			    			});
	    			    						} else {
	    			    							self.receipt.archiveDataReportExpiredTr = null;
	    			    							self.receipt.archiveDataReportCorrectTr = null;
	    			    						}
	
	    			    						receiptScope.loading = false;
	    			    					});
	    								} else {
	    									ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
			    								if (data.flgError == '1') {
			    			        				var detailMessage = data.messageAuditPopop;
			    			        				var fileUpload1 = 0;
			    			        				var fileUpload2 = 1;
	
			    			    					var modalInstance = $uibModal.open({
			    			    						animation : true,
			    			    						templateUrl : GLOBAL_URL
			    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
			    			    						controller : 'AuditConfirmController',
			    			    						controllerAs : 'vm',
			    			    						size : 'lg',
			    			    						resolve : {
			    			    							detailMessage : function() {
			    			    								return detailMessage;
			    			    							},
			    			    							fileUpload1 : function() {
			    			    								return fileUpload1;
			    			    							},
			    			    							fileUpload2 : function() {
			    			    								return fileUpload2;
			    			    							},
			    			    							receipt : function() {
			    			    								return self.receipt;
			    			    							}
			    			    						}
			    			    					});
			    			    					
			    			    					modalInstance.result.then(function(result) {
			    			    						if(result =='1') {
			    			    							saveContinue();
			    			    						} else {
			    			    							self.receipt.archiveDataReportExpiredTr = null;
			    			    							self.receipt.archiveDataReportCorrectTr = null;
			    			    						}
			    			    						
			    			    						receiptScope.loading = false;
			    			    					});
			    			    					
			    								} else {
			    									saveContinue();
			    								}
			    							}, function (error) {
			    								if(error.status !== 500) {
			    				        			self.receipt = error.data;
			    				        		}
			    				        		
			    				        		receiptScope.loading = false;
			    				        		
			    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
			    				        			self.receipt.countSubmit += 1;
			    				        		}
			    				        		
			    				        		if(self.receipt.countSubmit >= 2){
			    				        			 receiptScope.isDisable = true;
			    				        			 self.isDisableReceiptType = true;
			    				         		}
			    			    			});
	    								}
	    							}, function (error) {
	    								if(error.status !== 500) {
	    				        			self.receipt = error.data;
	    				        		}
	    				        		
	    				        		receiptScope.loading = false;
	    				        		
	    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	    				        			self.receipt.countSubmit += 1;
	    				        		}
	    				        		
	    				        		if(self.receipt.countSubmit >= 2){
	    				        			 receiptScope.isDisable = true;
	    				        			 self.isDisableReceiptType = true;
	    				         		}
	    			    			});
	    						}
	    						
	    						receiptScope.loading = false;
	    					});
	    				} else {
	    					ReceiptService.save({uri:"check-expired-tr"}, self.receipt, function(data) {
								
								if (data.flgError == '1') {
			        				var detailMessage = data.messageAuditPopop;
			        				var fileUpload1 = 1;
			        				var fileUpload2 = 0;
	
			    					var modalInstance = $uibModal.open({
			    						animation : true,
			    						templateUrl : GLOBAL_URL
			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
			    						controller : 'AuditConfirmController',
			    						controllerAs : 'vm',
			    						size : 'lg',
			    						resolve : {
			    							detailMessage : function() {
			    								return detailMessage;
			    							},
			    							fileUpload1 : function() {
			    								return fileUpload1;
			    							},
			    							fileUpload2 : function() {
			    								return fileUpload2;
			    							},
			    							receipt : function() {
			    								return self.receipt;
			    							}
			    						}
			    					});
			    					
			    					modalInstance.result.then(function(result) {
			    						if(result =='1') {
			    							ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
			    								if (data.flgError == '1') {
			    			        				var detailMessage = data.messageAuditPopop;
			    			        				var fileUpload1 = 0;
			    			        				var fileUpload2 = 1;
	
			    			    					var modalInstance = $uibModal.open({
			    			    						animation : true,
			    			    						templateUrl : GLOBAL_URL
			    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
			    			    						controller : 'AuditConfirmController',
			    			    						controllerAs : 'vm',
			    			    						size : 'lg',
			    			    						resolve : {
			    			    							detailMessage : function() {
			    			    								return detailMessage;
			    			    							},
			    			    							fileUpload1 : function() {
			    			    								return fileUpload1;
			    			    							},
			    			    							fileUpload2 : function() {
			    			    								return fileUpload2;
			    			    							},
			    			    							receipt : function() {
			    			    								return self.receipt;
			    			    							}
			    			    						}
			    			    					});
			    			    					
			    			    					modalInstance.result.then(function(result) {
			    			    						if(result =='1') {
			    			    							saveContinue();
			    			    						} else {
			    			    							self.receipt.archiveDataReportExpiredTr = null;
			    			    							self.receipt.archiveDataReportCorrectTr = null;
			    			    						}
			    			    						
			    			    						receiptScope.loading = false;
			    			    					});
			    			    					
			    								} else {
			    									saveContinue();
			    								}
			    							}, function (error) {
			    								if(error.status !== 500) {
			    				        			self.receipt = error.data;
			    				        		}
			    				        		
			    				        		receiptScope.loading = false;
			    				        		
			    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
			    				        			self.receipt.countSubmit += 1;
			    				        		}
			    				        		
			    				        		if(self.receipt.countSubmit >= 2){
			    				        			 receiptScope.isDisable = true;
			    				        			 self.isDisableReceiptType = true;
			    				         		}
			    			    			});
			    						} else {
			    							self.receipt.archiveDataReportExpiredTr = null;
			    							self.receipt.archiveDataReportCorrectTr = null;
			    						}
	
			    						receiptScope.loading = false;
			    					});
								} else {
									ReceiptService.save({uri:"check-correct-tr-rb"}, self.receipt, function(data) {
	    								if (data.flgError == '1') {
	    			        				var detailMessage = data.messageAuditPopop;
	    			        				var fileUpload1 = 0;
	    			        				var fileUpload2 = 1;
	
	    			    					var modalInstance = $uibModal.open({
	    			    						animation : true,
	    			    						templateUrl : GLOBAL_URL
	    			    						+ 'partial?uri=ga/receipt/proposal/individual/audit-confirm-dialog',
	    			    						controller : 'AuditConfirmController',
	    			    						controllerAs : 'vm',
	    			    						size : 'lg',
	    			    						resolve : {
	    			    							detailMessage : function() {
	    			    								return detailMessage;
	    			    							},
	    			    							fileUpload1 : function() {
	    			    								return fileUpload1;
	    			    							},
	    			    							fileUpload2 : function() {
	    			    								return fileUpload2;
	    			    							},
	    			    							receipt : function() {
	    			    								return self.receipt;
	    			    							}
	    			    						}
	    			    					});
	    			    					
	    			    					modalInstance.result.then(function(result) {
	    			    						if(result =='1') {
	    			    							saveContinue();
	    			    						} else {
	    			    							self.receipt.archiveDataReportExpiredTr = null;
	    			    							self.receipt.archiveDataReportCorrectTr = null;
	    			    						}
	    			    						
	    			    						receiptScope.loading = false;
	    			    					});
	    			    					
	    								} else {
	    									saveContinue();
	    								}
	    							}, function (error) {
	    								if(error.status !== 500) {
	    				        			self.receipt = error.data;
	    				        		}
	    				        		
	    				        		receiptScope.loading = false;
	    				        		
	    				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	    				        			self.receipt.countSubmit += 1;
	    				        		}
	    				        		
	    				        		if(self.receipt.countSubmit >= 2){
	    				        			 receiptScope.isDisable = true;
	    				        			 self.isDisableReceiptType = true;
	    				         		}
	    			    			});
								}
							}, function (error) {
								if(error.status !== 500) {
				        			self.receipt = error.data;
				        		}
				        		
				        		receiptScope.loading = false;
				        		
				        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
				        			self.receipt.countSubmit += 1;
				        		}
				        		
				        		if(self.receipt.countSubmit >= 2){
				        			 receiptScope.isDisable = true;
				        			 self.isDisableReceiptType = true;
				         		}
			    			});
	    				}
	    			}, function (error) {
	    				if(error.status !== 500) {
		        			self.receipt = error.data;
		        		}
		        		
		        		receiptScope.loading = false;
		        		
		        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
		        			self.receipt.countSubmit += 1;
		        		}
		        		
		        		if(self.receipt.countSubmit >= 2){
		        			 receiptScope.isDisable = true;
		        			 self.isDisableReceiptType = true;
		         		}
	    			});
	        	}, function(error){
	        		if(error.status !== 500) {
	        			self.receipt = error.data;
	        		}
	        		
	        		receiptScope.loading = false;
	        		
	        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
	        			self.receipt.countSubmit += 1;
	        		}
	        		
	        		if(self.receipt.countSubmit >= 2){
	        			 receiptScope.isDisable = true;
	        			 self.isDisableReceiptType = true;
	         		}
	        	});
    		} else {
    			saveContinue();
    		}
        }
    	
    	function saveContinue() {
			if (policyCtr.isThirdParty && !self.clickCheckThirdParty) {
    			self.addAlert("Vui lòng nhấn nút kiểm tra trước khi thực thiện tiếp.",'warning');
    			return;
    		}
    		
    		if (policyCtr.isThirdParty == true && (policyCtr.thirdParty.ctrycode != 'VN' || policyCtr.thirdParty.natlty != 'VN')) {
				receiptScope.loading = true;
				ReceiptService.get({uri:'check-aml-warning', country : policyCtr.thirdParty.ctrycode, nationality : policyCtr.thirdParty.natlty}, function(result) {
					if (result != null && result.messages === null) {
						if (result.checkAMLWarning == true) {
							var modalInstance = $uibModal.open({
			    				animation : true,
			    				templateUrl : GLOBAL_URL
			    				+ 'partial?uri=ga/receipt/policy/receipt-continue-aml-dialog',
			    				controller : 'ReceiptContinueAMLDialogController',
			    				controllerAs : 'continueAMLDlgCtr',
			    				size : 'lg'
			    			});
			    			modalInstance.result.then(function(result) {
			    				if (result == '1') {
			    					policyCtr.reset();
			    					return;
			    				} else if (result == '0') {
			    					save();
			    				}
			    				modalInstance = null;
			    			}, function() {
			    				receiptScope.loading = false;
			    			});
							receiptScope.loading = false;
						} else {
							save();
						}
					}
					receiptScope.loading = false;
				}, function(error){
					receiptScope.loading = false;
				});
			} else {
				save();
			}
        }
    	
    	function save() {
    		self.clearMessage();
    		receiptScope.loading = true;
    		self.receipt.currentUrl = $location.absUrl().split(GLOBAL_URL)[1];
    		if(self.receipt.paymentTypeCode == 'CASH'){
    			self.receipt.bankReceiptBrNum = null;
    			self.receipt.bankReceiptBankName = null;
    			self.receipt.bankReceiptBrDate = null;
    			self.receipt.bankReceiptBrAmount = null;
    		}else {
    			self.receipt.receiptAgNum = null;
    			self.receipt.receiptAgDate = null;
    			self.receipt.receiptAgAmount = null;
    		}

			self.receipt.thirdPartyInfoDto = policyCtr.thirdParty;
			if(self.receipt.countCallFiserv > 4 && (self.receipt.byPass == null || self.receipt.byPass == '')){
				policyCtr.showDialogConfirm();
				receiptScope.loading = false;
				return;
			}
			if ((policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) ||
    				(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) || 
    				(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    			
    			var dataFile = [];
	    		var urlFile = '';
    			
    			if ((policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					!(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					!(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['file'] = policyCtr.attachment;
    				urlFile = 'save-policy-temp';
    			} else if (!(policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					!(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['fileExpired'] = self.receipt.archiveDataReportExpiredTr;
    				urlFile = 'save-policy-temp-1';
    			} else if (!(policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					!(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['fileCorrect'] = self.receipt.archiveDataReportCorrectTr;
    				urlFile = 'save-policy-temp-2';
    			} else if ((policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					!(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['file'] = policyCtr.attachment;
    				dataFile['fileExpired'] = self.receipt.archiveDataReportExpiredTr;
    				urlFile = 'save-policy-temp-3';
    			} else if ((policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					!(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['file'] = policyCtr.attachment;
    				dataFile['fileCorrect'] = self.receipt.archiveDataReportCorrectTr;
    				urlFile = 'save-policy-temp-4';
    			} else if (!(policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['fileExpired'] = self.receipt.archiveDataReportExpiredTr;
    				dataFile['fileCorrect'] = self.receipt.archiveDataReportCorrectTr;
    				urlFile = 'save-policy-temp-5';
    			} else if ((policyCtr.attachment !== null && policyCtr.attachment !== undefined && self.dataFileName !== policyCtr.attachment.name) &&
    					(self.receipt.archiveDataReportExpiredTr != null && self.receipt.archiveDataReportExpiredTr != undefined) &&
    					(self.receipt.archiveDataReportCorrectTr != null && self.receipt.archiveDataReportCorrectTr != undefined)) {
    				dataFile['file'] = policyCtr.attachment;
    				dataFile['fileExpired'] = self.receipt.archiveDataReportExpiredTr;
    				dataFile['fileCorrect'] = self.receipt.archiveDataReportCorrectTr;
    				urlFile = 'save-policy-temp-6';
    			}

    			dataFile['receipt'] = new Blob([ JSON
					.stringify(self.receipt) ], {
    				type : "application/json"
    			});
        		
    			Upload.upload({
					url : GLOBAL_URL
							+ 'api/ga/receipt/' + urlFile,
					data : dataFile
    			}).then(
					function(resp) {
		        		receiptScope.isDisable = true;
		        		self.isDisableReceiptType = true;
		        		receiptScope.isTrrb = false;
		        		//for print receipt
		        		receiptScope.txnId = resp.data.transaction.txnId;
		        		receiptScope.receiptId = resp.data.receiptId;
		        		receiptScope.receiptsMustPrint = resp.data.receiptsMustPrint;
		        		receiptScope.paymentTypeCode = resp.data.paymentTypeCode;
		        		
		        		self.receipt = resp.data;
		        		receiptScope.loading = false;
		        		self.isBom = false;
		        		receiptScope.loading = false;
		        		receiptScope.checkContest(resp.data);
					},
					function(error) {
		        		if(error.status !== 500) {
		        			self.receipt = error.data;
		        		}
		        		receiptScope.loading = false;
		        		
		        		if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
		        			self.receipt.countSubmit += 1;
		        		}
		        		
		        		if(self.receipt.countSubmit >= 2){
		        			 receiptScope.isDisable = true;
		        			 self.isDisableReceiptType = true;
		         		}
					});
    		} else {
				ReceiptService.save({uri:"save-policy"}, self.receipt, function(data) {
					receiptScope.isDisable = true;
					self.isDisableReceiptType = true;
					receiptScope.isTrrb = false;
					//for print receipt
					receiptScope.txnId = data.transaction.txnId;
					receiptScope.receiptId = data.receiptId;
					receiptScope.receiptsMustPrint = data.receiptsMustPrint;
					receiptScope.paymentTypeCode = data.paymentTypeCode;

					self.receipt = data;
					self.isBom = false;
					receiptScope.loading = false;
					receiptScope.checkContest(data);
				}, function(error) {
					if(error.status !== 500) {
						self.receipt = error.data;
					}
					self.isClick =false;
					receiptScope.loading = false;

					if(error.headers('X-PRUGAGreatApp-error') === 'las.error'){
						self.receipt.countSubmit += 1;
					}

					if(self.receipt.countSubmit >= 2){
						receiptScope.isDisable = true;
						self.isDisableReceiptType = true;
					}
				});
			}
		}
    	
    	/*
    	 * Update status receipt when las suscess and prugreat fail
    	 */
    	policyCtr.updateReceipt = function () {
    		self.clearMessage();
    		receiptScope.loading = true;
    		if(self.receipt.paymentTypeCode == 'CASH'){
    			self.receipt.bankReceiptBrNum = null;
    			self.receipt.bankReceiptBankName = null;
    			self.receipt.bankReceiptBrDate = null;
    			self.receipt.bankReceiptBrAmount = null;
    		}else {
    			self.receipt.receiptAgNum = null;
    			self.receipt.receiptAgDate = null;
    			self.receipt.receiptAgAmount = null;
    		}
    		
    		ReceiptService.save({uri:"update-receipt"}, self.receipt, function(data){
        		receiptScope.isDisable = true;
        		self.isDisableReceiptType = true;
        	
        		//for print receipt
        		receiptScope.txnId = data.transaction.txnId;
        		receiptScope.receiptId = data.receiptId;
        		receiptScope.receiptsMustPrint = data.receiptsMustPrint;
        		receiptScope.paymentTypeCode = data.paymentTypeCode;
        		
        		self.receipt = data;
        		receiptScope.loading = false;
        		self.isBom = false;
        		if (data.receiptNum == null || data.receiptNum == '') {
        			self.isReceiptHaveLas = false;
        		}
        	}, function(error){
        		if(error.status !== 500)
        		{
        			self.receipt = error.data;
        		}
        		receiptScope.loading = false;
        	});
        }
    	
    	policyCtr.reset = function(){
     		//https://angular-ui.github.io/ui-router/site/#/api/ui.router.state.$state#methods_reload
    		
    		receiptScope.isDisable = false;
     		$state.transitionTo($state.current, {}, { 
   			  reload: true, inherit: false, notify: true
   			});
     	}   
    	
    	self.getPolicy = function() {
    		self.receiptTypesNotInEligibility = CommonService.query({masterurl:'receipt-types'}, function(result) {
    			self.receiptTypesNotInEligibility = _.remove(result, function(currentObject) {
    			    return currentObject.receiptTypeCode !== '7';
    			});
    		});
    		self.clearMessage();
    		receiptScope.loading = true;
    		var policyNum = self.receipt.policyNum;
			var paymentTypeCode = self.receipt.paymentTypeCode;
			if( self.receipt.ownerIdNum == undefined ||  self.receipt.ownerIdNum == null)
				self.receipt.ownerIdNum = '';
    		PolicyService.getPolicyByPolicyNum({method:'getPolicyByPolicyNum',policyNum:self.receipt.policyNum,clientIdNum:self.receipt.ownerIdNum}, function(result){
    			
    			self.clearReceipt();
    			
    			self.receipt.policyNum = policyNum;

				if((result.needToInputIDNumber == true)
					|| (self.receipt.ownerIdNum != ''
						&& self.receipt.ownerIdNum != undefined
						&& self.receipt.ownerIdNum != null
						&& self.receipt.ownerIdNum != result.ownerIdNum
					))
				{
					document.getElementById("labelmessage").style.display = "block";
					self.receipt.ownerIdNum = '';
					receiptScope.loading = false;
					return;
				}
				else{
					document.getElementById("labelmessage").style.display = "none";
					self.receipt.ownerIdNum = result.ownerIdNum;
				}

				self.policy = result;
				if(result.aml) {
    				var detailMessage = 'Bấm “Tiếp tục” để thực hiện tiếp, “Bỏ qua” để dừng thực hiện giao dịch';
    				var modalInstance = $uibModal
    				.open({
    					animation : true,
    					templateUrl : GLOBAL_URL
    					+ 'partial?uri=ga/receipt/policy/report-to-comp-dialog',
    					controller : 'ReportToCompDialogController',
    					controllerAs : 'vm',
    					size : 'lg',
    					resolve : {
    						detailMessage : function() {
    							return detailMessage;
    						}
    					}
    				});
    			}

				if(result.zautoter == "Y")
				{
					self.addAlert("Sản phẩm bổ trợ PRU-Hành Trang Vui Khỏe trong Hợp đồng bảo hiểm của Quý khách sẽ không được gia hạn \n" +
						"\n" +
						"Xem thông tin chi tiết tại ",
						'danger'
						, "https://khachhang.prudential.com.vn/customer-portal/web/eletterweb/index.html#/"
						, "E Letter (prudential.com.vn)");
				}
    			policyCtr.thirdParty = result.thirdPartyInfoDto;
    			
    			if (policyCtr.thirdParty != null) {
        			if(result.thirdPartyInfoDto.archiveData != null) {
        				console.log("result.thirdPartyInfoDto.archiveData: " + result.thirdPartyInfoDto.archiveData);
        				
        				policyCtr.attachment = {
    						name : result.thirdPartyInfoDto.archiveData.dataName,
    						content : result.thirdPartyInfoDto.archiveData.content,
    						type : result.thirdPartyInfoDto.archiveData.dataType
    					};
        				
        				self.dataFileName = result.thirdPartyInfoDto.archiveData.dataName;
    				}
        			policyCtr.thirdParty.birthdayDate = new Date(result.thirdPartyInfoDto.birthDay);
    			}
    			
    			if (result.thirdPartyInfoDto != null) {
    				policyCtr.isThirdParty = true;
				}

    			self.changeTypeCodeFindPolicy();
    			if(result.gaRankCode != null && result.gaRankCode != undefined && result.gaRankDesc != null && result.gaRankDesc != undefined ){
					self.receipt.transaction.gaRankCode = result.gaRankCode;
    				self.receipt.transaction.gaRankDesc = result.gaRankDesc;
				}
    			self.receipt.transaction.customerName = result.ownerName;
    			self.receipt.transaction.policyOwner = result.ownerName;
    			self.receipt.transaction.productCode = result.contractCode;
    			self.receipt.paymentTypeCode = paymentTypeCode;
    			self.receipt.receiptPremiumAmount = result.premiumAmount;  
	    		self.receipt.premiumAmountDefault = result.premiumAmount;  
	    		self.receipt.dayPolicy = result.dayPolicy;
				if(result.d61D70){
					self.receipt.d61D70 = true;
				}
				else {
					self.receipt.d61D70 = false;
				}
	    		policyCtr.laspeActionN = result.laspeActionN;
    			if(result.eligibility) {
					self.receiptTypes = self.receiptTypesAll;
				}else{
					self.receiptTypes = self.receiptTypesNotInEligibility;
				}   
    			
    			if(result.policyULP){
    				self.receipt.policyULP = result.policyULP;
    				if(result.statusCode === 'IF')
    				{
    					_.remove(self.receiptTypes, function(currentObject) {
        				    return currentObject.receiptTypeCode !== self.PDK && currentObject.receiptTypeCode !== self.KK;
        				    self.receipt.receiptTypeCode = self.PDK;
        				});
    				} else if(result.statusCode !== 'IF')
    				{
    					_.remove(self.receiptTypes, function(currentObject) {
        				    return currentObject.receiptTypeCode !== self.KK;
        				});
    					self.receipt.receiptTypeCode = self.KK;
    				}
    					
    				if (self.receipt.receiptTypeCode == self.PDK)
    					self.receipt.showDescription = true;
    				else
    					self.receipt.showDescription = false;
    				
    				self.receipt.receiptPtdRider = getPtdRider(self.policy.paidToDateRider);
    				
    			} else {
    				// ChangeRequest 5.0
    				if(result.statusCode !== 'IF')
    				{
    					_.remove(self.receiptTypes, function(currentObject) {
        				    return currentObject.receiptTypeCode !== self.KK;
        				});
    					self.receipt.receiptTypeCode = self.KK;
    				}
    			}
    			self.changeTypeCodeFindPolicy();
    			//self.changeStatusReceiptDueDate();
    			var clientCode = result.contactAddressCode == null ? result.ownerCode : result.contactAddressCode;
    			self.receipt.transaction.customerCode = clientCode;
    			self.isFullyPaid = result.fullyPaid; 
    			self.isDisablePDKorKKFind = result.disablePDKorKK;
    			if(result.disablePDKorKK && (self.receipt.receiptTypeCode === self.PDK || self.receipt.receiptTypeCode === self.KK)) {
    				//self.addAlert(CONST_COMMON.FULLY_PAID,'warning');
    				//receiptScope.isDisable = result.fullyPaid;
    				self.isDisablePDKorKK = result.disablePDKorKK;
    			}
    			CustomerService.get({uri:"get-customer-by-clientCode", clientCode:clientCode},function(dataCus) {
    				self.receipt.customer = dataCus;
    				// Neu policy thi luu proposalNum la policy de lay thong tin khach hang
    				self.receipt.customer.proposalNum = policyNum;
    			})
    			receiptScope.policyNumDisable = true;
    			receiptScope.loading = false;
    		}, function(respone){
    			receiptScope.loading = false;
    		})
    	};
    	
    	self.changeTypeCodeFindPolicy = function(){
    		self.receipt.principalDebtAmount = 0;
    		self.receipt.interestDebtAmount = 0;
    		
    		self.changeStatusReceiptDueDate();
    		
    		if(self.receipt.receiptTypeCode === self.HTTD || self.receipt.receiptTypeCode === self.HTTU) {
    			self.clearMessage();
    			$timeout(function(){
    				if((parseFloat(self.receipt.principalDebtAmount) + parseFloat(self.receipt.interestDebtAmount)) <=0){
        				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',false);	
            			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',false);
        			}
            		else {
            			self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',true);
            			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',true);
            		}
    			},500);
    		}
    		
    		if(self.receipt.receiptTypeCode === self.PG) {
    			self.receipt.receiptSubTypeCode = self.SubType_10;
    		}
    		if(self.receipt.policyULP && self.receipt.receiptTypeCode === self.PDK)
    			self.receipt.showDescription = true;
			else
				self.receipt.showDescription = false;
    		if(self.receipt.receiptTypeCode != self.PDK && self.receipt.receiptTypeCode != self.PG && (self.policy.statusCode !== 'PS')){
    			self.receipt.receiptTotalAmount = self.receipt.receiptAgAmount = self.receipt.bankReceiptBrAmount  = self.policy.receiptDeductAmount = 0;
    			return;
    		}
    	
    		caculatorReceiptAmount();
    	}
    	
    	self.changeTypeCode = function(){
    		self.clearMessage();
    		self.isDisablePDKorKK = false;
    		if(self.receipt.receiptTypeCode == self.PDK || self.receipt.receiptTypeCode == self.KK) {
    			/*if(self.isFullyPaid) {
    				self.addAlert(CONST_COMMON.FULLY_PAID,'warning');
    				receiptScope.isDisable = self.isFullyPaid;
    			}*/
    			if(self.isDisablePDKorKKFind) {
    				self.isDisablePDKorKK = self.isDisablePDKorKKFind;
    			}
    		} else {
    			receiptScope.isDisable = false;
    		}
    		self.receipt.principalDebtAmount = 0;
    		self.receipt.interestDebtAmount = 0;
    		
    		self.changeStatusReceiptDueDate();
    		
    		if(self.receipt.receiptTypeCode === self.HTTD || self.receipt.receiptTypeCode === self.HTTU) {
    			$timeout(function(){
    				if((parseFloat(self.receipt.principalDebtAmount) + parseFloat(self.receipt.interestDebtAmount)) <=0){
        				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',false);	
            			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',false);
        			}
            		else {
            			self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',true);
            			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',true);
            		}
    			},500);
    			if(self.policy.validFlag === 'Y'){
    				self.addAlert(CONST_COMMON.POLICY_LOAN_99,'warning');
    			}
    		}
    		
    		if(self.receipt.receiptTypeCode === self.PG) {
    			self.receipt.receiptSubTypeCode = self.SubType_10;
    		}
    		if(self.receipt.policyULP && self.receipt.receiptTypeCode === self.PDK)
    			self.receipt.showDescription = true;
			else
				self.receipt.showDescription = false;
    		if(self.receipt.receiptTypeCode != self.PDK && self.receipt.receiptTypeCode != self.PG ){
    			self.receipt.receiptTotalAmount = self.receipt.receiptAgAmount = self.receipt.bankReceiptBrAmount  = self.policy.receiptDeductAmount = 0;
    			return;
    		}
    	
    		caculatorReceiptAmount();
    	};
    	
    	$scope.$watch('policy.paidToDateAdvance', function(formattedDate){
    		self.policy.paidToDateAdvance = $filter('date')(formattedDate, 'dd/MM/yyyy');
    	});
    	 
    	$scope.$watch('policy.firstIssuanceDate', function(formattedDate){
    		self.policy.firstIssuanceDate = $filter('date')(formattedDate, 'dd/MM/yyyy');
    	});
    	
    	$scope.$watch('policy.paidToDateRider', function(formattedDate){
    		self.policy.paidToDateRider = $filter('date')(formattedDate, 'dd/MM/yyyy');
    	});
    	
    	self.changeReceiptAgAmount = function(newValue){

    		if(newValue === undefined || newValue === "" || newValue === 0){
    			newValue = 0;
    			/*if(self.editForm.receiptAgAmount !== undefined){
    				self.editForm.receiptAgAmount.$setValidity('amountBiggerZero',false);
    				return;
    			}*/
			}

			self.totalAmountThirdPartyTemp = self.totalAmountThirdParty + parseFloat(newValue);

    		/*if(self.editForm.receiptAgAmount !== undefined){
				self.editForm.receiptAgAmount.$setValidity('amountBiggerZero',false);
			}*/
    		self.editForm.receiptAgAmount.$setValidity('amountBiggerZero',true);
    		if(self.receipt.principalDebtAmount === undefined || self.receipt.principalDebtAmount === "")
    			self.receipt.principalDebtAmount = 0;
    		if(self.receipt.interestDebtAmount === undefined || self.receipt.interestDebtAmount === "")
    			self.receipt.interestDebtAmount = 0;
    		// Trả gốc + Trả lãi ≠ Số tiền  khi Về khoản = “Hoàn trả…”
    		if(self.receipt.paymentTypeCode == 'CASH' && self.editForm.receiptAgAmount != null && (self.receipt.receiptTypeCode ==='2' || self.receipt.receiptTypeCode ==='3')) {
    			var totalPrincipalDebtAndInterestDebt = parseFloat(self.receipt.principalDebtAmount) + parseFloat(self.receipt.interestDebtAmount);
        		if(totalPrincipalDebtAndInterestDebt !== parseFloat(newValue)) {
        			self.editForm.receiptAgAmount.$setValidity('amountInvalid',false);	
        		}else {
        			self.editForm.receiptAgAmount.$setValidity('amountInvalid',true);
        		}
    		}
    		self.receipt.receiptTotalAmount = parseFloat(newValue);
    	}

    	
    	self.changeBankReceiptBrAmount = function(newValue){
    		if(newValue === undefined || newValue === "" || newValue === 0){
    			newValue = 0;
    			/*if(self.editForm.bankReceiptBrAmount !== undefined){
    				self.editForm.bankReceiptBrAmount.$setValidity('amountBiggerZero',true);
    				return;
    			}*/
    		}
    		/*if(self.editForm.receiptAgAmount !== undefined){
    			self.editForm.bankReceiptBrAmount.$setValidity('amountBiggerZero',false);
			}*/
    		if(self.receipt.principalDebtAmount === undefined || self.receipt.principalDebtAmount === "")
    			self.receipt.principalDebtAmount = 0;
    		if(self.receipt.interestDebtAmount === undefined || self.receipt.interestDebtAmount === "")
    			self.receipt.interestDebtAmount = 0;
    		// Trả gốc + Trả lãi ≠ Số tiền  khi Về khoản = “Hoàn trả…”
    		if(self.receipt.paymentTypeCode != 'CASH' &&  self.editForm.bankReceiptBrAmount != null && (self.receipt.receiptTypeCode ==='2' || self.receipt.receiptTypeCode ==='3')) {
    			var totalPrincipalDebtAndInterestDebt = parseFloat(self.receipt.principalDebtAmount) + parseFloat(self.receipt.interestDebtAmount);
        		if(totalPrincipalDebtAndInterestDebt !== parseFloat(newValue)) {
        				self.editForm.bankReceiptBrAmount.$setValidity('amountInvalid',false);	
        		}else {
        				self.editForm.bankReceiptBrAmount.$setValidity('amountInvalid',true);
        		}	
    		}
    		self.receipt.receiptTotalAmount = parseFloat(newValue);
    	}
    	
    	self.changePrincipalDebtAmount = function(newValue){
    		
    		if(newValue === undefined || newValue === ""){
    			if(self.editForm.principalDebtAmount !== undefined){
    				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',true);	
    			}
    			
    			if(self.editForm.interestDebtAmount !== undefined){
	    			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',true);
    			}
    			return false;
    			//newValue = self.receipt.principalDebtAmount = 0;
    		}
    		if(self.receipt.receiptAgAmount=== undefined || self.receipt.receiptAgAmount === "")
    			self.receipt.receiptAgAmount = 0;
    		if(self.receipt.interestDebtAmount === undefined || self.receipt.interestDebtAmount === "")
    			self.receipt.interestDebtAmount = 0;
    		if(self.receipt.receiptTypeCode === self.HTTD || self.receipt.receiptTypeCode === self.HTTU) {
    			var totalAmount = parseFloat(newValue) + parseFloat(self.receipt.interestDebtAmount);
    			if(self.receipt.paymentTypeCode === 'CASH')
    				self.receipt.receiptAgAmount = totalAmount;
    			else
    				self.receipt.bankReceiptBrAmount = totalAmount;
    			if(totalAmount <=0) {
    				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',false);	
    				self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',false);
				}else {
					self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',true);	
	    			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',true);
	    			
	    			// Trả gốc > số tiền gốc APL khi Về khoản = “Hoàn trả đóng phí tự động”
    				// Hoặc Trả gốc > số tiền gốc OPL khi Về khoản = “Hoàn trả tạm ứng GTHL”
	    			// var totalApl = parseFloat(self.policy.aplAmount) + parseFloat(self.policy.aplInterestAmount);
    				// var totalOpl = parseFloat(self.policy.oplAmount) + parseFloat(self.policy.oplInterestAmount);
    				if ((self.receipt.receiptTypeCode === self.HTTD && parseFloat(newValue) > parseFloat(self.policy.aplAmount)) 
	    					|| (self.receipt.receiptTypeCode === self.HTTU && parseFloat(newValue) > parseFloat(self.policy.oplAmount))) {
	    				self.editForm.principalDebtAmount.$setValidity('principalDebtAmountBiggerAplOrOpl',false);	
	    			}else {
	    				self.editForm.principalDebtAmount.$setValidity('principalDebtAmountBiggerAplOrOpl',true);
	    			}
				}
    			// Trả gốc + Trả lãi ≠ Số tiền  khi Về khoản = “Hoàn trả…”
    			if(self.receipt.paymentTypeCode == 'CASH') {
    				if(totalAmount !== parseFloat(self.receipt.receiptAgAmount)) {
        				self.editForm.receiptAgAmount.$setValidity('amountInvalid',false);
        			}else {
        				self.editForm.receiptAgAmount.$setValidity('amountInvalid',true);
        			}
    			}else {
    				if(totalAmount !== parseFloat(self.receipt.bankReceiptBrAmount)) {
        				self.editForm.bankReceiptBrAmount.$setValidity('amountInvalid',false);
        			}else {
        				self.editForm.bankReceiptBrAmount.$setValidity('amountInvalid',true);
        			}
    			}
    		}
    		self.receipt.receiptTotalAmount = parseFloat(newValue)+parseFloat(self.receipt.interestDebtAmount);
    	}
    
    	self.changeInterestDebtAmount = function(newValue){
    		
    		if(newValue === undefined || newValue === ""){
    			if(self.editForm.principalDebtAmount  !== undefined ){
    				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',true);	
    			}

    			if(self.editForm.interestDebtAmount  !== undefined ){
	    			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',true);
    			}
    			return false;
    		}
    		if(self.receipt.principalDebtAmount === undefined || self.receipt.principalDebtAmount === "")
    			self.receipt.principalDebtAmount = 0;
    		if(self.receipt.receiptAgAmount === undefined || self.receipt.receiptAgAmount === "")
    			self.receipt.receiptAgAmount = 0;
    		if(self.receipt.receiptTypeCode === self.HTTD || self.receipt.receiptTypeCode === self.HTTU) {
    			var totalAmount = parseFloat(newValue) + parseFloat(self.receipt.principalDebtAmount);
    			if(self.receipt.paymentTypeCode === 'CASH')
    				self.receipt.receiptAgAmount = totalAmount;
    			else
    				self.receipt.bankReceiptBrAmount = totalAmount;
    			if(totalAmount <=0){
    				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',false);	
        			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',false);
    			}else {
    				self.editForm.principalDebtAmount.$setValidity('amountBiggerZero',true);	
        			self.editForm.interestDebtAmount.$setValidity('amountBiggerZero',true);
    			}
    			// var totalApl = parseFloat(self.policy.aplAmount) + parseFloat(self.policy.aplInterestAmount);
				// var totalOpl = parseFloat(self.policy.oplAmount) + parseFloat(self.policy.oplInterestAmount);
				if ((self.receipt.receiptTypeCode === self.HTTD && parseFloat(newValue) > parseFloat(self.policy.aplInterestAmount)) 
    					|| (self.receipt.receiptTypeCode === self.HTTU && parseFloat(newValue) > parseFloat(self.policy.oplInterestAmount))) {
    				self.editForm.interestDebtAmount.$setValidity('interestDebtAmountBiggerAplOrOpl',false);	
    			}else {
    				self.editForm.interestDebtAmount.$setValidity('interestDebtAmountBiggerAplOrOpl',true);
    			}
				// Trả gốc + Trả lãi ≠ Số tiền  khi Về khoản = “Hoàn trả…”
				if(self.receipt.paymentTypeCode == 'CASH') {
    				if(totalAmount !== parseFloat(self.receipt.receiptAgAmount)) {
        				self.editForm.receiptAgAmount.$setValidity('amountInvalid',false);
        			}else {
        				self.editForm.receiptAgAmount.$setValidity('amountInvalid',true);
        			}
    			}else {
    				if(totalAmount !== parseFloat(self.receipt.bankReceiptBrAmount)) {
        				self.editForm.bankReceiptBrAmount.$setValidity('amountInvalid',false);
        			}else {
        				self.editForm.bankReceiptBrAmount.$setValidity('amountInvalid',true);
        			}
    			}
    		}
    		self.receipt.receiptTotalAmount = parseFloat(newValue)+parseFloat(self.receipt.principalDebtAmount);
    	}
    	
    	$scope.$watch("policy.receiptDeductAmount", function (newValue) {
    		if(newValue === undefined || newValue === "")
    			newValue = 0;
    		
    		self.receipt.receiptDeductAmount = newValue;    		
		});
    	
    	$scope.$watch("policy.premiumAmount", function (newValue) {
    		if(newValue === undefined || newValue === null || newValue === "")
    			newValue = 0;
    		
    		self.receipt.receiptPremiumAmount = newValue;  
    		self.receipt.premiumAmountDefault = newValue;    		
		});
    	
    	$scope.$watch("policy.servicingAgentCode", function (newValue) {
    		if(newValue === undefined || newValue === "")
    			newValue = null;
    		
    		self.receipt.servicingAgentCode = newValue;    		
		});
    	
    	$scope.$watch("policy.suspenseAmount", function (newValue) {
    		if(newValue === undefined || newValue === "")
    			newValue = 0;
    		
    		self.receipt.suspenseAmountDefault = newValue;    		
		});
    	
    	$scope.$watch("policy.policyIPLorULP", function (newValue) {
    		if(newValue === undefined || newValue === "")
    			newValue = false;
    		
    		self.receipt.policyIPLorULP = newValue;    		
		});
    	
        // Datetimepicker 
        policyCtr.datePickerOpenStatus = {};
        policyCtr.datePickerOpenStatus.receiptAgDate = false;
        policyCtr.datePickerOpenStatus.receiptDueDate = false;
        policyCtr.openCalendar = openCalendar;
        function openCalendar (date) {
            policyCtr.datePickerOpenStatus[date] = true;
        }
        
        self.filterReceiptSubTypeByCode = function (param) {
            return function (item) {
                if (item.receiptTypeCode === param) {
                    return true;
                }
                return false;
            };
        };
        
        self.filterPaymentType = function (){
        	return function (item) {
                if (item.paymentTypeCode !== 'OTHER') {
                    return true;
                }
                return false;
            };
        }
        
        self.clearReceipt = function(){
        	self.receipt = angular.copy(policyCtr.receiptMaster);
        }
        
        function changeStatusReceiptDueDate(){
        	if(self.receipt.paymentTypeCode === 'CASH') {
        		if(self.receipt.receiptTypeCode === self.PDK && self.policy.allReceiptDueDates != undefined && self.policy.allReceiptDueDates.length > 0)
        			self.receipt.receiptDueDate = self.policy.allReceiptDueDates[0];
            	else{
            		self.receipt.receiptDueDate = '';
            	}
        	}
        }
        
        /*
         * Get Agent
         */
        policyCtr.getAgent = function(code){
    		if(code == undefined) return;
    		if(code != undefined || code != ''){
    			var numCode = Number(code);
    			if(numCode < 10000000) numCode += 60000000;
    			self.receipt.receiptAgentCode = numCode.toString();
    		}
    		if (self.receipt.receiptAgentCode != undefined && self.receipt.receiptAgentCode.length == 8){
    			ReceiptService.getAgent({uri: 'get-agent',agentCode:self.receipt.receiptAgentCode}, function(result){
    				self.receipt.receiptAgentName = result.agentName;
    				self.receipt.receiptAgentCode = result.agentCode;
    				if(result.gaRankCode != null && result.gaRankCode != undefined && result.gaRankDesc != null && result.gaRankDesc != undefined ){
    					self.receipt.transaction.gaRankCode = result.gaRankCode;
        				self.receipt.transaction.gaRankDesc = result.gaRankDesc;
    				}
    				/*if(self.receipt.paymentTypeCode === 'CASH')
    					receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
  						      self.receipt.receiptAgNum, 'RB', 
  						      self.receipt.receiptAgentCode, 
  						      self.receipt.receiptAgDate);
    				if(self.receipt.paymentTypeCode !== 'CASH')
    					receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
    							self.receipt.bankReceiptBrNum, 'RB', 
							      self.receipt.receiptAgentCode, 
							      self.receipt.bankReceiptBrDate);*/
    			}, function(error){
    				self.receipt.receiptAgentName = null;
    			});
    		}
    	}
        
        self.receiptDueDateChange = function(receiptDueDate){
        	//$filter('date')(receiptDueDate, 'dd/MM/yyyy');
        }
        
        function getPtdRider(receiptPtdRider){
        	if(receiptPtdRider !=null || receiptPtdRider != undefined)
        		return moment(receiptPtdRider, 'DD/MM/YYYY');
    		else
    			return null;
        }
        
        function receiptDateChange(policyNum, receiptAgDate){
        	receiptAgDate = $filter('date')(receiptAgDate, 'dd/MM/yyyy');
        	
    		ReceiptService.returnValue({uri:'caculator-receipt-amount', policyNum:policyNum, receiptDate:receiptAgDate},function(result){
    			
    			if (self.receipt.paymentTypeCode == 'CASH'){
    		        self.receipt.receiptTotalAmount = self.receipt.receiptAgAmount =  result.response;
    			}else{
    		        self.receipt.receiptTotalAmount = self.receipt.bankReceiptBrAmount =  result.response;
    	    	}
    			
    		},function(error){
    		});
    	}
    	
        function caculatorReceiptAmountByReceiptTypeIsPG(){
        	var discrate            = self.policy.discrate;
			var remainPrePayment    = self.policy.remainPrePayment;
	        var disPrePayment       = self.policy.disPrePayment;
	        var premiumAmountInt    = self.policy.premiumAmount
	        var deductAmountInt     = self.policy.receiptDeductAmount = 0;
	      
        	var totslAmountIntBeforeDis = premiumAmountInt*remainPrePayment;
	        var totalAmountIntAfterDis= totslAmountIntBeforeDis - (premiumAmountInt*(discrate/10000) - deductAmountInt)*disPrePayment;
	            
	        return  Math.ceil(totalAmountIntAfterDis)
        }
        function caculatorReceiptAmount(){
        	if (self.receipt.paymentTypeCode == 'CASH'){
    			if(self.policy.receiptDeductAmount === undefined || self.policy.receiptDeductAmount === '')
    				self.policy.receiptDeductAmount = 0;
    			
    			if(self.policy.premiumAmount === undefined || self.policy.premiumAmount === '')
    				self.policy.premiumAmount = 0;
    			
    			if(self.receipt.receiptTypeCode == self.PDK){

        			var currentDate = new Date();
        			currentDate.setHours(0, 0, 0,0);

        			//var paidToDateAdvance = moment(self.policy.paidToDateAdvance,"DD/MM/YYYY");
        			var paidToDateAdvance = new Date(self.policy.paidToDateAdvance);
        			paidToDateAdvance.setHours(0, 0, 0,0);
        			if(!self.policy.policyIPLorULP) {
        				if (currentDate.getTime() <= paidToDateAdvance.getTime()) {
            				if(parseFloat(self.policy.premiumAmount) >= 330600) {
            					self.policy.receiptDeductAmount = 0;
            					self.policy.receiptDeductAmount = 5000;
            				}
            			}else {
            				 var paidToDateAdvanceConvert = new Date(self.policy.paidToDateAdvance);
            				 paidToDateAdvanceConvert.setHours(0, 0, 0,0);
            				 var d1 = moment(self.policy.paidToDateAdvance); 
            				 var d2 = moment(currentDate); 
            				 var days = moment.duration(d2.diff(d1)).asDays();
            				 if(parseInt(days) == 1 || parseInt(days) == 0) {
            					 if((paidToDateAdvanceConvert.getDay() === 6 || paidToDateAdvanceConvert.getDay() === 0) 
             							&& (currentDate.getDay() === 0 || currentDate.getDay() === 1)) {
             						if(parseFloat(self.policy.premiumAmount) >= 330600) {
             							self.policy.receiptDeductAmount = 0;
                     					self.policy.receiptDeductAmount = 5000;
                     				}
             					}
            				 }
            			}
        			}
        			self.receipt.receiptTotalAmount = self.receipt.receiptAgAmount = parseFloat(self.policy.premiumAmount) - parseFloat(self.policy.receiptDeductAmount);
        		}else if(self.receipt.receiptTypeCode == self.PG){
    	            self.receipt.receiptTotalAmount = self.receipt.receiptAgAmount =  caculatorReceiptAmountByReceiptTypeIsPG();
        		}
    		}else{
    			self.policy.receiptDeductAmount = 0;
    			
    			if(self.policy.premiumAmount === undefined || self.policy.premiumAmount === '')
    				self.policy.premiumAmount = 0;
    			
    			if(self.receipt.receiptTypeCode == self.PDK){
    				self.receipt.receiptTotalAmount = self.receipt.bankReceiptBrAmount = parseFloat(self.policy.premiumAmount);
        		}else if(self.receipt.receiptTypeCode == self.PG){
    	            self.receipt.receiptTotalAmount = self.receipt.bankReceiptBrAmount =  caculatorReceiptAmountByReceiptTypeIsPG();
        		}
        	}
        }
        
        
    	/*
    	 * Check currentDate - receiptDate > 3 -> showWarning
    	 */
        /*
    	 * Check currentDate - receiptDate > 3 -> showWarning
    	 */
    	function checkReceiptDate() {
    		self.clearMessage();
    		var currentDate = new Date();
    		if (self.receipt.paymentTypeCode == 'CASH')
	    	{	
    	    	if (self.receipt.receiptAgDate != null && self.editForm.receiptAgDate != null) {
        	        var receiptAgDate =  moment(self.receipt.receiptAgDate,"DD/MM/YYYY");
 
        	        if (currentDate > receiptAgDate.add(3, 'days')){
        	        	self.addAlert('Tư vấn viên vi phạm chậm nộp phí quá 3 ngày.','warning');
        	        }
        	        if (Number($filter('date')(self.receipt.receiptAgDate,'yyyyMMdd')) <= Number($filter('date')(currentDate, 'yyyyMMdd'))) {
    	        		self.editForm.receiptAgDate.$setValidity('dateBiggerCurrentDate',true);	
    	        		if(self.receipt.receiptSubTypeCode == '11'){
    	        			receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
    							      self.receipt.receiptAgNum, 'TR', 
    							      self.receipt.receiptAgentCode, 
    							      self.receipt.receiptAgDate);
    	        		}else {
    	        			receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
  							      self.receipt.receiptAgNum, 'RB', 
  							      self.receipt.receiptAgentCode, 
  							      self.receipt.receiptAgDate);
    	        		}
        	        }
        	        else{
        	        	self.editForm.receiptAgDate.$setValidity('dateBiggerCurrentDate',false);
        	        }
        	        
        	    }
	    	}
    	    else{
    	    	if (self.receipt.bankReceiptBrDate != null && self.editForm.bankReceiptBrDate != null) {
        	        var bankReceiptBrDate = moment(self.receipt.bankReceiptBrDate,"DD/MM/YYYY");
 
        	        if (currentDate > bankReceiptBrDate.add(3, 'days')){
        	        	self.addAlert('Tư vấn viên vi phạm chậm nộp phí quá 3 ngày.','warning');
        	        }
        	        if (Number($filter('date')(self.receipt.bankReceiptBrDate,'yyyyMMdd')) <= Number($filter('date')(currentDate, 'yyyyMMdd'))) {
        	        	self.editForm.bankReceiptBrDate.$setValidity('dateBiggerCurrentDate',true);	
        	        	receiptScope.receiptCtr.checkTrRbNum(self.receipt.paymentTypeCode, 
							      self.receipt.bankReceiptBrNum, 'RB', 
							      self.receipt.receiptAgentCode, 
							      self.receipt.bankReceiptBrDate);
        	        }
        	        else{
        	        	self.editForm.bankReceiptBrDate.$setValidity('dateBiggerCurrentDate',false);	
        	        }
        	        
        	    }
    	    }
    	}
    	//Add days
    	Date.prototype.AddDays = function(noOfDays) {
    	    this.setTime(this.getTime() + (noOfDays * (1000 * 60 * 60 * 24)));
    	    return this;
    	}
    	
    	function receiptCancelReason(receiptId){
    		if (receiptId == undefined || receiptId == null) return false;
    		policyCtr.lstReceiptCancelReason = ReceiptService.query({uri:'receipt-cancel-reason'}, function(data){
    			policyCtr.animationsEnabled = true;
				var modalInstance = 
					//show dialog
					$uibModal.open({
						animation : policyCtr.animationsEnabled,
						templateUrl : GLOBAL_URL+ 'partial?uri=ga/receipt/receipt-cancel-reason-dialog',
						controller : 'ReceiptCancelReasonDialogController as cancelReasonDlgCtr',
						size : 'lg',
						resolve : {
							lstReceiptCancelReason : function() {
								return data;//tranfer data for dialog
							},
							receipt: function(){
								return self.receipt;
							}
						}
				});
				modalInstance.result.then(function(result) {
					self.receipt = result;
					self.receipt.transaction.busWfCode = 'CANCELED';
					self.receipt.transaction.txnEnable = '0';
					self.receipt.transaction.wfStatus='RECEIPT_END';
					receiptScope.isDisableCancelReason = true;
					receiptScope.isDisable = true;
					self.isDisableReceiptType = true;
					self.isRevert = true;
				},
				function(error){
					
				});
    		},
    		function(error){
    		});
    		
    	}
    	
    	function startsWithProposalETrrb(bookletCash,bookletNocash,paymentType, receiptSubTypeCode) {
    		if(bookletCash == null || bookletCash == undefined) bookletCash = '';
    		if(bookletNocash == null || bookletNocash == undefined) bookletNocash = '';
    		if(paymentType == null) paymentType = '';
    		if(self.receipt.eTrrbReceiptId != null && self.receipt.eTrrbReceiptId != undefined) {
    			if(receiptSubTypeCode == '11'){
        			if(paymentType == 'CASH') {
            			if(bookletCash.substring( 0, 1) == '1' && bookletCash !='111111111'){
            				return true;
            			}else {
            				return false;
            			}
            		}else if(paymentType == 'BANK' || paymentType == 'POST') {
            			if(bookletNocash.substring( 0, 1) == '1' && bookletNocash !='111111111'){
            				return true;
            			}else {
            				return false;
            			}
            		}
        		}
    		}
    		return false;
    	}
    	
    	policyCtr.revertReceipt = function(){
    		self.loading = true;
    		self.clearMessage();
    		var handlerData = {'txnId': receiptScope.txnId};
    		ReceiptService.post({uri:'submit-receipt-cancel-to-success'}, handlerData,function(result){
    			self.loading = false;
    			self.receipt.cancelReasonCode = null;
    			self.receipt.transaction.cancelReasonCode = null;
    			self.receipt.transaction.txnEnable = '1';
    			self.receipt.transaction.busWfCode = 'SUCCESS';
    			self.isRevert = false;
			},
			function(error){
				self.loading = false;
			});
		};
		
		policyCtr.savePolReversal = function () {
    		self.clearMessage();
    		receiptScope.loading = true;
    		policyCtr.checkCreatD61D70 = true;
    		if(self.receipt.receiptTypeCode != '4'){
    			self.addAlert('Vui lòng chọn [Về khoản] = [Khoản khác].','error');
    			policyCtr.checkCreatD61D70 = false;
    			receiptScope.loading = false;
    			return;
    		}
    		if(self.receipt.receiptSubTypeCode != '1'){
    			self.addAlert('Vui lòng chọn [Diễn giải] = [Tạm thu khôi phục HĐ-PT1].','error');
    			policyCtr.checkCreatD61D70 = false;
    			receiptScope.loading = false;
    			return;
    		}
    		var modalInstance = $uibModal
			.open({
				animation : true,
				templateUrl : GLOBAL_URL
				+ 'partial?uri=ga/receipt/policy/receipt-confirm-pol-reversal-dialog',
				controller : 'ReceiptPolReversalDialogController',
				controllerAs : 'polReversalDlgCtr',
				size : 'lg'
			});
			modalInstance.result.then(function(result) {
				// approveCtr.loadCustomerInfo(clientCode);
				if (result == '1') {
					receiptScope.loading = false;
					policyCtr.checkCreatD61D70 = false;
					return;
				} else if (result == '0') {
					receiptScope.loading = false;
		    		if(self.receipt.paymentTypeCode == 'CASH'){
		    			self.receipt.bankReceiptBrNum = null;
		    			self.receipt.bankReceiptBankName = null;
		    			self.receipt.bankReceiptBrDate = null;
		    			self.receipt.bankReceiptBrAmount = null;
		    		}else {
		    			self.receipt.receiptAgNum = null;
		    			self.receipt.receiptAgDate = null;
		    			self.receipt.receiptAgAmount = null;
		    		}
		    		
		    		ReceiptService.save({uri:"save-policy-reversal"}, self.receipt, function(data){
		    			receiptScope.isDisable = true;
		    			self.isDisableReceiptType = true;
		    			policyCtr.checkCreatD61D70 = true;
		        		receiptScope.txnId = data.transaction.txnId;
		        		receiptScope.receiptId = data.receiptId;
		        		receiptScope.paymentTypeCode = data.paymentTypeCode;
		        		
		        		self.receipt = data;
		        	}, function(error){
		        		if(error.status !== 500)
		        		{
		        			self.receipt = error.data;
		        		}
		        		receiptScope.loading = false;
		        		policyCtr.checkCreatD61D70 = false;
		        		
		        	});
				}
				modalInstance = null;
			}, function() {
				receiptScope.loading = false;
				policyCtr.checkCreatD61D70 = false;
			});
        }
		
		policyCtr.release=function(){
			self.receipt.transaction.createdDate = null;
	    	$scope.loading= true;
	    	self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
	    	ReceiptService.post({uri:'do-release-approve-d61d70'},self.receipt, function(result) {
			 if(result){
				 $scope.loading= false;
				 window.location.href = GLOBAL_URL+'task#/common-task';
			 }
			}, function(error){
				$scope.loading= false;
			});
		};
		
		policyCtr.approvePolicyReversal=function(){
			receiptScope.loading = true;
			self.clearMessage();
			self.receipt.transaction.createdDate = null;
			self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
			ReceiptService.post({uri:'approval-policy-reversal'},self.receipt, function(result) {
				receiptScope.loading=false;
				 if(result != null && result.flgError == '0'){
					 self.receipt.transaction.printStatus = result.transaction.printStatus;
					 self.receipt.transaction.txnEnable = result.transaction.txnEnable;
					 self.receipt.transaction.wfStatus = result.transaction.wfStatus;
					 policyCtr.checkApprovalD61D70 = true;
					 policyCtr.showHistoryD61D70 = true;
				 }else if (result != null && result.flgError == '1' && (result.stepD6170Error == 2 || result.stepD6170Error == 3 || result.stepD6170Error == 4)){
					 self.receipt.desSendPs = result.desSendPs;
					 self.receipt.receiptNum = result.receiptNum;
					 self.receipt.msgSendPs = result.msgSendPs;
					 var modalInstance = $uibModal
						.open({
							animation : true,
							templateUrl : GLOBAL_URL
							+ 'partial?uri=ga/receipt/policy/receipt-send-ps-dialog',
							controller : 'ReceiptSendPsDialogController',
							controllerAs : 'sendPsDlgCtr',
							size : 'lg',
							resolve : {
								
								stepStr: function(){
									return result.desSendPs;
								},
								numStep: function(){
									return result.stepD6170Error;
								}
							}
						});
						modalInstance.result.then(function(result) {
							modalInstance = null;
							if (result == '1') {
								receiptScope.loading = false;
								policyCtr.checkCreatD61D70 = false;
								return;
							} else if (result == '0') {
								receiptScope.loading = false;
								policyCtr.sendToPs();
							}
							
						}, function() {
							receiptScope.loading = false;
						});
				 }
				 
			}, function(error){
				receiptScope.loading=false;
			});
		
		};
		
		policyCtr.sendToPs=function(){
			self.clearMessage();
			self.receipt.transaction.createdDate = null;
			receiptScope.loading= true;
			self.receipt.taskInstanceId = $base64.decode($stateParams.taskId);
			ReceiptService.post({uri:'send-to-ps'},self.receipt, function(result) {
				receiptScope.loading=false;
				 policyCtr.checkApprovalD61D70 = true;
			}, function(error){
				receiptScope.loading=false;
				
			});
		
		};
		
		policyCtr.cancelAppove = function(receiptId){
    		if (receiptId == undefined || receiptId == null) return false;
    		self.receipt.transaction.createdDate = null;
    		policyCtr.lstCancelD61D70Reason = ReceiptService.query({uri:'get-all-cancel-reason'}, function(data){
    			policyCtr.animationsEnabled = true;
				var modalInstance = 
					//show dialog
				$uibModal.open({
					animation : policyCtr.animationsEnabled,
					templateUrl : GLOBAL_URL+ 'partial?uri=ga/receipt/policy/receipt-cancel-d61d70-dialog',
					controller : 'ReceiptCancelD61D70DialogController as cancelD61d70DlgCtr',
					size : 'lg',
					resolve : {
						lstCancelD61D70Reason : function() {
							return data;//tranfer data for dialog
						},
						receipt: function(){
							return self.receipt;
						}
					}
				});
				modalInstance.result.then(function(result) {
//					self.receipt = result;
					self.receipt.transaction.busWfCode = 'CANCELED';
					self.receipt.transaction.txnEnable = '0';
					receiptScope.isDisableCancelReason = true;
					receiptScope.isDisable = true;
					policyCtr.checkApprovalD61D70 = true;
					self.isRevert = true;
				},
				function(error){
					
				});
    		},
    		function(error){
    		});
    		
    	};
    	$scope.$watch('receipt.createdDate', function(formattedDate){
    		self.receipt.createdDate = $filter('date')(formattedDate, 'dd/MM/yyyy');
    	});
    	
    	policyCtr.printLetterD6170 = function() {
        	if(self.receipt.transaction.txnId != undefined){
        		var txnId = self.receipt.transaction.txnId;
        		ReceiptService.get({uri:'check-print-letter',txnId :txnId },function(result){
       			 if(result.keyCheckPrint == true){
       				policyCtr.keyCheckPrint =true;
       				self.addAlert('Thư đã được upload lên Filenet. Vui lòng xem lại thư.','warning');
       			}else{
       				ReceiptService.download({uri:'print-letter-confirm-d6170'}, self.receipt);
       			}
       		});
        		
        	}
        };
        policyCtr.viewLetterD6170 = function() {
        	if(self.receipt.transaction.txnId != undefined){
        		ReceiptService.download({uri:'print-letter-confirm-d6170'}, self.receipt);
        	}
        };
        policyCtr.loadPage= function(){
        	receiptScope.loading= true;
        	if(($stateParams.taskId != undefined && $stateParams.taskId != '' && $stateParams.taskId != null)){
        		var txnId = self.receipt.transaction.txnId;
            	ReceiptService.get({uri:'check-valid-d6170',txnId :txnId },function(result){
            		receiptScope.loading= false;
        			if(result.keyCheck == 'false'){
        				policyCtr.keyCheck =false;
        			}else if(result.keyCheck == 'true'){
        				policyCtr.keyCheck =true;
        				self.receipt.desSendPs = result.desSendPs;
        				self.receipt.msgSendPs = result.msgSend;
        				self.addAlert('Không thực hiện được giao dịch. Lý do [ '+result.desSendPs+']. Vui lòng chuyển về PS','warning');
        			}
        		},
				function(error){
        			receiptScope.loading= false;
				});
        	}
        	receiptScope.loading= false;
        	
		};

		policyCtr.changeCheckThirdParty = function(value) {
    		policyCtr.thirdParty = {};
    		policyCtr.attachment = null;
    		self.clickCheckThirdParty = false;
    		if(value) {
    			policyCtr.thirdParty.ctrycode = 'VN';
				policyCtr.thirdParty.natlty = 'VN';
			}
    	};
    	
    	policyCtr.changeTextThirdParty = function() {
    		self.clickCheckThirdParty = false;
    	};
    	
    	policyCtr.findInfoThirdParty = function() {
    		receiptScope.loading= true;
    		if (policyCtr.thirdParty.securityNo != undefined && policyCtr.thirdParty.securityNo != null) {
    			ReceiptService.get({uri:'get-info-third-party', securityNo : policyCtr.thirdParty.securityNo}, function(result) {
    				if (result != null && result.securityNo != null) {
    					policyCtr.thirdParty = result;
    					policyCtr.thirdParty.birthdayDate = new Date(policyCtr.thirdParty.birthDay);
    				}
    			},
				function(error){
        			receiptScope.loading= false;
				});
    		}
    		receiptScope.loading= false;
    	};
    	
    	policyCtr.checkThirdParty = function() {
    		if (policyCtr.thirdParty.birthdayDate != undefined && policyCtr.thirdParty.surName != undefined && policyCtr.thirdParty.givName != undefined) {
    			receiptScope.loading= true;
        		// start
				// copy data to new Object
				var receiptCheck = JSON.parse(JSON.stringify(self.receipt));
				policyCtr.thirdParty.givName = policyCtr.thirdParty.givName.toUpperCase();
				policyCtr.thirdParty.surName = policyCtr.thirdParty.surName.toUpperCase();
        		receiptCheck.thirdPartyInfoDto = policyCtr.thirdParty;
				ReceiptService.checkThirdPartyFiserv({uri:'check-third-party-in-fiserv'}, receiptCheck, function(result) {
						receiptScope.loading = false;
						if(result != null && result.flgError != '0'){
							if(result.countCallFiserv > 4){
								policyCtr.showDialogConfirmByPass();
							}
							return;
						}
						checkThirdPartyBeforeCallFiserv(true);
						return;
					},
					function(error){
						receiptScope.loading = false;
						return;
					});
				// end
    		}
    	}

    	var checkThirdPartyBeforeCallFiserv = function(accept){
            if (policyCtr.thirdParty.birthdayDate != undefined && policyCtr.thirdParty.surName != undefined && policyCtr.thirdParty.givName != undefined) {
                receiptScope.loading= true;
                var securityNo = '';
                if (policyCtr.thirdParty.securityNo != undefined && policyCtr.thirdParty.securityNo != null) {
                    securityNo = policyCtr.thirdParty.securityNo;
                }

                ReceiptService.returnValue({uri:'check-third-party',
                        securityNo : securityNo,
                        birthDay : $filter('date')(policyCtr.thirdParty.birthdayDate, 'dd/MM/yyyy'),
                        surName : policyCtr.thirdParty.surName,
                        givName : policyCtr.thirdParty.givName
                    }, function(result) {
                        receiptScope.loading = false;
                        self.totalAmountThirdParty = parseFloat(result.response);
                        self.totalAmountThirdPartyTemp = self.totalAmountThirdParty + parseFloat(self.receipt.receiptAgAmount);

                        if (result.response == 0) {
                            self.addAlert('Khách hàng chưa có giao dịch trong ngày','warning');
                        } else {
                            var message = 'Khách đã có giao dịch trong ngày. Số tiền 3rd party đã nộp đến thời điểm hiện tại là ' + self.totalAmountThirdPartyTemp;

                            if (self.totalAmountThirdPartyTemp >= '300000000') {
                                message = message + '. Vui lòng attach CMND / CCCD / Passport của người nộp tiền trước khi gửi đi';
                            }

                            self.addAlert(message, 'warning');
                        }
						if(accept) {
							self.clickCheckThirdParty = true;
						}
                    },
                    function(error){
                        receiptScope.loading = false;
                    });
                receiptScope.loading = false;
            }
        }
    	
    	policyCtr.changeThirdParty = function(value) {
    		if (value != undefined && value != null) {
    			var lstThirdParty = policyCtr.lstThirdParty;
    			for (var i = 0; i < lstThirdParty.length; i++) {
    				if (lstThirdParty[i].code == value) {
    					policyCtr.thirdParty.group = lstThirdParty[i].shortDesc;
    				}
    			}
    		} else {
    			policyCtr.thirdParty.group = '';
    		}
    	};
    	
    	policyCtr.download = function() {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
																		// IE
																		// browser
				if (policyCtr.attachment.content != undefined) {
					var byteCharacters = atob(policyCtr.attachment.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : policyCtr.attachment.type + ';charset=utf-8'
					});
					window.navigator.msSaveBlob(blob,
							policyCtr.attachment.name);
				} else {
					var blob = new Blob([ policyCtr.attachment ], {
						type : policyCtr.attachment.type + ';charset=utf-8'
					});
					window.navigator.msSaveBlob(blob,
							policyCtr.attachment.name);
				}
			} else {
				// truong hop file da luu duoi database
				if (policyCtr.attachment.content != undefined) {
					var byteCharacters = atob(policyCtr.attachment.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : policyCtr.attachment.type + ';charset=utf-8'
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = policyCtr.attachment.name;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ policyCtr.attachment ], {
						type : policyCtr.attachment.type + ';charset=utf-8'
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = policyCtr.attachment.name;
					aTag.click();
				}
			}
		};
		
		policyCtr.showDialogConfirm = function() {
			policyCtr.animationsEnabled = true;
			var modalInstance =
			// show dialog
			$uibModal
					.open({
						animation : policyCtr.animationsEnabled,
						templateUrl : GLOBAL_URL
								+ 'partial?uri=ga/receipt/alert-dialog',
						controller : 'AlertDialogController as alertDlgCtr',
						size : 'lg'
					});
			modalInstance.result.then(function(result) {
				// get id assigner and update db
				self.receipt.byPass = result;
				save();
			}, function(error) {
			});
		};

		policyCtr.showDialogConfirmByPass = function() {
			policyCtr.animationsEnabled = true;
			var modalInstance =
				// show dialog
				$uibModal
					.open({
						animation : policyCtr.animationsEnabled,
						templateUrl : GLOBAL_URL
							+ 'partial?uri=ga/receipt/confirm-fiserv-status-dialog',
						controller : 'ConfirmFiservStatusDialogController as confirmFiservStatusDlgCtr',
						size : 'sm'
					});
 			modalInstance.result.then(function(result) {
// 				// get id assigner and update db
				self.receipt.byPass = 'GA';
				self.receipt.status = result.toUpperCase();
				checkThirdPartyBeforeCallFiserv(result.toUpperCase() != 'HITDECLINE');
 			}, function(error) {
 			});
		};
    }
})();
